const PowerFlowConfigurationEndpoint = {
  SAVE: '/battery/power-flow-configuration/save',
  SAVE_PV_PRODUCTION: '/battery/power-flow-configuration/save-pv-production',
  SAVE_CONSUMPTION: '/battery/power-flow-configuration/save-consumption',
  SAVE_GRID: '/battery/power-flow-configuration/save-grid',
  SAVE_BATTERY: '/battery/power-flow-configuration/save-battery',
  SAVE_WIZARD: '/battery/power-flow-configuration/save-wizard',
  GET: '/battery/power-flow-configuration/get',
  GET_METERS: '/battery/power-flow-configuration/get-meters',
  GET_BATTERIES: '/battery/power-flow-configuration/get-batteries',
  GET_CONFIG: '/battery/power-flow-configuration/get-config',
};

export default PowerFlowConfigurationEndpoint;
